export default  {
  count: state => state.count,
  list: state => Object.values(state.tags),
  tags: state => state.tags,
  types: state => state.types,
  selectedTags: state => state.selected,
  isSelected: state => tag => state.selected.filter(t => t.name == tag.name).length==1,
  selectedByType: state => type => state.selected.filter(t => t.type == type),
  selectedNames: state => state.selected.map(a => a.name),
  item: state => name => state.list[name]
}